// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global handorgel */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),
        screenWidth: window.innerWidth,

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        //__stickyMessageHander: function() {
        //    let newsletterOffset = undefined;
//
        //    function elementScrolled(elem) {
        //        var docViewTop = $(window).scrollTop();
        //        var docViewBottom = docViewTop + $(window).height();
        //        var elemTop = $(elem).offset().top;
        //        return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
        //    }
//
        //    $(window).scroll(function() {
        //        if(elementScrolled('.page-section-newsletter')) {
        //            if(!newsletterOffset) newsletterOffset = $(window).scrollTop();
        //            $(".sticky-message").css("top",Math.max(0,790-newsletterOffset));
        //        } else {
        //            $(".sticky-message").css("top", '790px');
        //        }
        //    });
        //},

        __initializeHandorgelAccordions: function() {
            const $accordions = wntrTheme.body.find('.handorgel');

            if($accordions.length) {
                $.each($accordions, function() {
                    const collapsible = $(this).data('collapsible');
                    new handorgel($(this)[0], {
                        initialOpenTransition: false,
                        initialOpenTransitionDelay: 0,
                        collapsible: collapsible
                    });
                });
            }
        },

        __toogleHeaderMenu: () => {
            const mobileBtn = wntrTheme.body.find('.toggle-menu');
            const mobileMenu = wntrTheme.body.find('.mobile-menu');
            const languageMenu = wntrTheme.body.find('.language-menu');
            const languageBtn = wntrTheme.body.find('.mobile-menu__select-language');
            const toggleLanguageMenu = wntrTheme.body.find('.language-menu__toggle-menu');
            const desktopToggleLanguageMenu = wntrTheme.body.find('.header__language-selector');

            mobileBtn.on('click', function() {
                mobileBtn.toggleClass('is-active');
                mobileMenu.toggleClass('is-active');
                wntrTheme.body.toggleClass('is-fixed');
            });

            languageBtn.on('click', function() {
                languageMenu.addClass('is-active');
            });

            toggleLanguageMenu.on('click', function() {
                languageMenu.removeClass('is-active');
            });

            desktopToggleLanguageMenu.on('click', function() {
                $(this).toggleClass('is-active');
            });
        },

        __handleActiveCompanyCard: () => {
            const toggle = wntrTheme.body.find('.btn--company');
            const companyCards = wntrTheme.body.find('.company-card');

            if(toggle.length && wntrTheme.screenWidth <= 1024) {
                toggle.on('click', function() {
                    toggle.removeClass('is-active');
                    $(this).addClass('is-active');

                    companyCards.removeClass('is-active');

                    const cardRef = $(this).data('ref');
                    $(".company-card[data-ref='" + cardRef +"']").addClass('is-active');
                });
            }
        },
        
    };

    $(document).ready(wntrTheme.init);
})(jQuery);